import React from 'react';

import Layout from '../components/Layout';
import PageFooter from '../components/PageFooter';
import SideBar from '../components/SideBar';

import pic2 from '../assets/images/pic2.jpg';
import pic4 from '../assets/images/pic4.jpg';
import pic6 from '../assets/images/pic6.jpg';
import pic9 from '../assets/images/pic09.jpg';
import meme from '../assets/images/meme.jpg';
import guitar from '../assets/images/guitar-shop.jpg';
import template from '../assets/images/template.jpg';
import Scroll from '../components/Scroll';

const sections = [
  { id: 'top', name: 'Intro', icon: 'fa-home' },
  { id: 'portfolio', name: 'Portfolio', icon: 'fa-th' },
  { id: 'about', name: 'About Me', icon: 'fa-user' },
  { id: 'contact', name: 'Contact', icon: 'fa-envelope' },
];

const IndexPage = () => (
  <Layout>
    <SideBar sections={sections} />

    <div id="main">
      <section id="top" className="one dark cover">
        <div className="container">
          <header>
            <h2 className="alt">
              Hello. I'm <strong>David</strong>.
              <br />
              Full Stack Developer
            </h2>
          </header>

          <footer>
            <Scroll type="id" element={'portfolio'}>
              <a href="#portfolio" className="button">
                Show me more
              </a>
            </Scroll>
          </footer>
        </div>
      </section>

      <section id="portfolio" className="two">
        <div className="container">
          <header>
            <h2>Works</h2>
          </header>

          {/* <div>
            <p>
              Experienced marketing professional, innovative optimised solution
              seeker graduated from Massey university and a front-end developer
              with Full Stack experience from Computer Power Plus institute.
              Dedicated self-starter specialising in web application
              development.
            </p>
          </div> */}

          <div className="row">
            <div className="col-4 col-12-mobile">
              <article className="item">
                <a href="http://david-blogs.netlify.com" className="image fit">
                  <img src={pic2} alt="personal blog" />
                </a>
                <header>
                  <h3>Personal Blog</h3>
                </header>
              </article>
              <article className="item"></article>
            </div>
            <div className="col-4 col-12-mobile">
              <article className="item">
                <a
                  href="https://david-movie-database.netlify.app"
                  className="image fit"
                >
                  <img src={pic4} alt="movie-app" />
                </a>
                <header>
                  <h3>Movie Database</h3>
                </header>
              </article>
              <article className="item"></article>
            </div>
            <div className="col-4 col-12-mobile">
              <article className="item">
                <a
                  href="https://corona19-tracker-app.netlify.app/"
                  className="image fit"
                >
                  <img src={pic6} alt="covid-19" />
                </a>
                <header>
                  <h3>Covid-19 Tracker</h3>
                </header>
              </article>
            </div>
            <div className="col-4 col-12-mobile">
              <article className="item">
                <a
                  href="https://guitar-ecommerce.netlify.app"
                  className="image fit"
                >
                  <img src={guitar} alt="guitar shop" />
                </a>
                <header>
                  <h3>Guitar Ecommerce</h3>
                </header>
              </article>
              <article className="item"></article>
            </div>
            <div className="col-4 col-12-mobile">
              <article className="item">
                <a
                  href="https://davidyao-portfolio.netlify.app/"
                  className="image fit"
                >
                  <img src={template} alt="blog template" />
                </a>
                <header>
                  <h3>Blog Template</h3>
                </header>
              </article>
              <article className="item"></article>
            </div>
            <div className="col-4 col-12-mobile">
              <article className="item">
                <a
                  href="https://david-blog-site.netlify.app/"
                  className="image fit"
                >
                  <img src={meme} alt="memes" />
                </a>
                <header>
                  <h3>Memes Creator</h3>
                </header>
              </article>
              <article className="item"></article>
            </div>
          </div>
        </div>
      </section>

      <section id="about" className="three">
        <div className="container">
          <header>
            <h2>About Me</h2>
          </header>

          <a href="/#" className="image featured">
            <img src={pic9} alt="" />
          </a>

          <article style={{ textAlign: 'left', color: 'black' }}>
            <p>
              Experienced full stack developer with proven end-to-end
              development skills to leverage extensive knowledge and experience
              to build interactive and user centered website design to scale.
            </p>
            <p>
              I am self-motivated with the ability prioritise tasks and products
              the work required by the deadline. Over 5 years' enterprise
              experience of product/marketing management with software
              development background and along with demonstrated history of
              working in the international trading and manufacturing industry in
              agile team environment.
            </p>
          </article>
          <section>
            <ul>
              <li>
                Experienced <strong>business manager</strong> with IT background
                working in the e-commerce and trading industry.
              </li>
              <li>
                Website/Software development using HTML5, CSS3, JavaScript and
                various frameworks such as React, Nodejs, Express.
              </li>
              <li>
                Design of interactives and web apps in an agile development
                environment.
              </li>
              <li>
                UX and UI design projects improving load time, site stickiness
                and user engagement
              </li>
              <li>
                Skilled in Negotiation, management, product analysis ,
                Fast-Moving Consumer Goods Marketing Strategy, and Supply Chain
                Management.
              </li>
            </ul>
          </section>
        </div>
      </section>

      <section id="contact" className="four">
        <div className="container">
          <header>
            <h3>Contact</h3>
          </header>

          <p>
            If you have any questions, comments, ideas, critiques, or you just
            want to say hi, don't hesitate to send me an email at
            davidyao2011@hotmail.com!
          </p>

          {/* <form method="post" action="#">
            <div className="row">
              <div className="col-6 col-12-mobile">
                <input type="text" name="name" placeholder="Name" />
              </div>
              <div className="col-6 col-12-mobile">
                <input type="text" name="email" placeholder="Email" />
              </div>
              <div className="col-12">
                <textarea name="message" placeholder="Message" />
              </div>
              <div className="col-12">
                <input type="submit" value="Send Message" />
              </div>
            </div>
          </form> */}
        </div>
      </section>
    </div>

    <PageFooter />
  </Layout>
);

export default IndexPage;
